var BlimpExtV2 = new Class({
	Extends: Blimp,

	options: {
		show_veil: true,
		opaque_popup: false,
		veil_opacity: 0.7,
		rpc_url: null,
		allow_others: false,
		cache: true,
		auto_open: false,
		backOnClose: false,
		scrollable: true,
		allowToClose: false,
		put_others_behind: false,
		fullscreen: false,
		withThumbnails: false,
		display: null,
		page: null
	},

	initialize: function (link, options) {
		this.setOptions(options);
		this._link = link || new Element('a', { 'href': '#', 'data-rpc': this.options.rpc_url, 'style': 'display: none' }).inject(document.body); //works even without any real link (useful for maps)
		this.opts = this.options;
		this.draggable = this.options.draggable;
		this.state = false;
		this.build();
		if (this.options.auto_open) {
			this._link.fireEvent('click');
		}
	},

	build: function () {
		Blimp.instances.include(this);
		this.addEvent('hide', this.destroy_and_rebuild.bind(this));

		this.active = true;
		this.first_load = true;
		this.parent();

		if (this.options.draggable) {
			window.addEvents({
				'resize': function () {
					if (Core.is_visible(this._element)) {
						this.center_popup();
					}
				}.bind(this)
			});
		}

		if (!this.options.scrollable && (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android')) {
			this.options.scrollable = true;
		}
		if (this.options.draggable && !this.options.scrollable) {
			window.addEvents({
				'scroll': function () {
					if (Core.is_visible(this._element)) {
						this.center_popup();
					}
				}.bind(this)
			});
		}
	},

	retrieve_url: function () {
		var url = this._link.getAttribute('data-rpc') || this._link.get('href') || this.options.rpc_url;

		if (!url || url == '' || url == '#') return;

		var first_char = url.substring(0, 1);

		if (first_char == '#') {
			url = url.substring(1, url.length);
			this._link.set('data-rpc', url);
		}
		return url;
	},

	destroy_and_rebuild: function () {
		this._element.dispose();
		if (this._link) {

			this._link.removeEvents('click');

			this._link.addEvent('click:once', function (e) {
				if (e && e.stop) {
					e.stop();
				}
				this.fx = null;
				this.fireEvent('fetch', [this, this._link]);
				this.fetch(this._link.get('data-rpc') || this._link.get('href'));
			}.bind(this));
		}
	},

	get_data: function (data) {
		var cls = this._link.getProperty('class');
		if (this._link.getProperty('data-class')) {
			cls = this._link.getProperty('data-class');
		}

		var _onpage_content = this._link.getNext('.' + cls + '_content') || this._link.getElement('.' + cls + '_content') || this._link.getParent().getElement('.' + cls + '_content');

		if (_onpage_content) {
			this.content = _onpage_content.dispose();
			this.content.removeClass(cls + '_content').addClass(cls + '_box');

			if (data) {
				this.data = data;
			}
		} else if (data) {
			this.data = data;

			if (this.options.get_content) {
				this.content = this.options.get_content(this, data);
			} else if (data.content) {
				this.content = (new Element('.' + cls + '_box', { html: this.data.content })).dispose();
			}
		} else {
			document.body.style.cursor = 'default';
			return;
		}
		this.process();
	},

	post_process: function () {
		var self = this;
		if (!this.content.getParent()) {
			this.inject(this.content);

			if (this.options.show_veil) {
				this.content.addClass('_has_veil');
			}
			if (this.options.opaque_popup) {
				this.content.addClass('opaque_popup');
			}
		}

		if (this.loader) {
			this.loader.minus();
		}

		if (this.options.show_veil) {
			this.build_veil();
		}

		this.post_process_build();

		document.body.style.cursor = 'default';

		let popupHasClassV = this.content && this.content.querySelector('.w_popup') && this.content.querySelector('.w_popup').classList.contains('_v3');
		if ((popupHasClassV && this.first_load) || !popupHasClassV) {
			this.fireEvent('postRpc', this);
		}

		if (this.data && this.data.status && this.data.status == true) {
			this.fireEvent('success');
		}

		// add sign up links
		this.add_signup_links();
	},

	submit: function (ev) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		var self = this;
		window.crRecaptcha.execute(function () { self.handle_form_submit() });

		// remove click callback
		this.content.getElement('.button').removeEvents('click');
	},

	post_process_build: function () {
		var _email_us = this._element.getElement('.w_blimp_contact_us') || this._element.getElement('.w_blimp_form.button');

		if (_email_us) {
			new Blimp.Form(_email_us, {
				draggable: true,
				show_veil: true,
				allow_others: this.options.fullscreen ? true : false,
				put_others_behind: this.options.fullscreen || this.options.put_others_behind ? true : false
			});
		}
		var _encrypted = this._element.getElements('.encrypted');
		if (_encrypted && _encrypted.length > 0) {
			_encrypted.each(function (el) {
				Core.add_encrypted_link(el);
			});
		}

		Core.add_videos_link(this._element);

		this.fireEvent('beforeShow');
		this.show();
	},

	show: function () {
		if (!this.options.allow_others || this.options.put_others_behind) {
			Blimp.instances.each(function (blp) {
				if (blp && blp != this && blp.state != false) {
					if (this.options.put_others_behind) {
						blp._element.addClass('_behind');
					} else {
						blp.hide();
					}
				}
			}.bind(this));
		}

		document.body.style.cursor = 'default';

		if (this.data) {
			this.implement_tracking(this.data);
		}

		if (!!this._element) {
			this._element.removeClass(Gv.cloak);
			this._element.removeClass(Gv.hidden);
		}

		if (this.draggable && !this.options.get_content)
			this.center_popup();

		if (this.options.show_veil) {
			this.handle_self_show();
		}

		this.state = true;
		this.fireEvent('show', [this]);
	},

	hide: function () {
		if (this.options.put_others_behind) {
			Blimp.instances.each(function (blp) {
				if (blp && blp != this && blp.state != false) {
					if (this.options.put_others_behind) {
						blp._element.removeClass('_behind');
					}
				}
			}.bind(this));
		} else if (this._element.hasClass('_behind')) {
			this._element.removeClass('_behind');
			Blimp.instances.each(function (blp) {
				if (this != blp && blp.state) {
					blp.hide();
				}
			}.bind(this));
			return;
		}

		// close only the save message popup
		if (this.onSavePopup && this.save_blimp) {
			this.save_blimp.hide();

			return;
		}

		if (this.options.backOnClose) {
			window.history.back();

			return;
		}

		if (this.options.auto_open && !this.options.allowToClose) return;

		this.fireEvent('beforeHide');

		// for Market insight landing page
		document.fireEvent('miPopupClose');

		if (this._element) {
			this._element.addClass(Gv.cloak);
			this._element.addClass(Gv.hidden);

			if (this.options.show_veil) {
				this.handle_self_hide();
			}

			this.state = false;
			this.fireEvent('hide', [this]);
		}
	},

	handle_self_show: function () {
		if (!this._veil) {
			return;
		}
		this._veil.fade(this.options.veil_opacity);
	},

	handle_self_hide: function () {
		if (!this._veil) {
			return;
		}
		this._veil.fade('out');
	},

	build_veil: function () {
		this.parent();

		this._veil.addClass(this.options.cls + '_veil');
		this._veil.inject(document.id(document.body), 'top');

		this._veil.removeEvents().addEvent('click', function () {
			if (!this.options.backOnClose) {
				this.hide();
			}
		}.bind(this));
	},

	fetch: function (location) {
		if (!this.active) {
			return;
		}

		document.body.style.cursor = 'wait';

		if (this.loader) {
			this.loader.plus();
		}

		if (this.request) {
			this.request.cancel();
		}

		if (!this.options.cache) {
			this.content = null;
			if (this._sv) this._sv = null;
			if (this._pg) this._pg = null;
			if (this._fp) this._fp = null;
			if (this._mp) this._mp = null;
			if (this._vd) this._vd = null;
			if (this._videos) this._videos = null;
		}

		if (!this.content || !this.options.cache) {
			if (location && location != '' && location != '#') {
				this.request = new Request.JSON({
					url: location,
					noCache: true,
					onSuccess: function (data) {
						this.get_data(data);
						if (!this.options.cache) {
							this.request = null;
						}

						this.add_contact_button(this._element);

					}.bind(this)
				}).get();
			} else {
				this.get_data();
			}
		} else {
			// this.content.dispose();
			this.process();
		}
	},

	add_contact_button: (element) => {
		let contactButton = element.getElement('.button-contact');
		if (contactButton) {
			contactButton.addEvent('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				var event;
				event = document.createEvent("HTMLEvents");
				event.initEvent("crPopupOpen-" + contactButton.getAttribute('data-popup-name'), true, true);
				document.dispatchEvent(event);
			});
		}
	},

	center_popup: function () {
		this._element.setStyles({
			position: 'absolute'
		});

		var win_scroll = window.getScroll(),
			win_size = window.getSize(),
			el_size = this._element.getSize();

		var pos_y = this.positionY = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y) / 2));

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			win_size.x = Math.max(win_size.x, document.getElement('body').offsetWidth);
		}

		var pos_x = this.positionX = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x) / 2));

		if (this.options.fullscreen) {
			this._element.setStyles({
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				'margin-top': 0
			});
			let bodyId = document.body.getAttribute('id');
			let bottomBar = document.body.getElement('.bottom-bar');
			if (!!bodyId && bodyId == 'hom' && !!bottomBar) {
				bottomBar.setStyles({ 'z-index': 100 });
			}
		} else if (this.options.animation) {
			if (!this.fx) {
				this.fx = new Fx.Morph(this._element, { link: 'cancel', transition: 'back:out', duration: 0 });
				this.fx.set({
					'top': pos_y,
					'left': pos_x
				});
			} else {
				this.fx.start({
					'top': pos_y,
					'left': pos_x
				});
			}
		} else {
			this._element.setStyles({
				top: pos_y,
				left: pos_x
			});
		}
	},

	add_extra: function (noCompile) { //used in SearchResultsMap
		if (this.options.cache && !this.first_load) {
			return;
		}

		var self = this;

		this.first_load = false;
		this.links_work = false;

		this._popup = this._element.getElement('.w_popup');
		this._monitor = this._element.getElement('.photogalleryv2_container');
		if (!noCompile) {
			Core.compile_html(self._element.getElement('.cr-save-to-profile'));
		}

		this.add_links_functionality();
		this.add_in_contract_functionality();

		// display the current widget
		this.show_widget(this.options.display);

		new Blimp.Form(this._element.getElement('.w_blimp_form.link-icon'), {
			draggable: true,
			show_veil: false,
			allow_others: true,
			put_others_behind: true
		});

		var _signin_links = this._element.getElements('.w_blimp_signin');
		if (_signin_links) {
			_signin_links.each(function (_link) {
				_link.addEvent('click', function () {
					self.hide();
				});
			})
		}

		// To compile
		let compile = true;
		// check if the contact popup already exists or not
		let contactButton = this._element.getElement('.button-contact');
		if (contactButton) {
			let popupName = contactButton.getAttribute('data-popup-name');
			// check if there is already existing popup outisde of the current element
			let popups = document.getElements(`cr-popup[data-popup-name="${popupName}"].ng-isolate-scope`);
			if (popups && popups.length > 0) {
				compile = false;
			}
		}
		var toCompile = this._element.getElement('.to-compile');
		if (!noCompile && compile && toCompile) {
			Core.compile_html(toCompile);
		}

		// For Listing Contact button
		var _contact_btn = this._element.getElement('.contact_btn');
		if (_contact_btn) {
			_contact_btn.addEvent('click', function (e) {
				self._popup.addClass('_on_contact_form');

				if (self.has_the_form) {
					var _close_btn = self._element.getElement('.form_wrapper .close_btn');
					_close_btn && _close_btn.focus();
					return;
				}

				self.has_the_form = true;
				Core.compile_html(self._element.getElement('.form_wrapper'));

				var _close_btn = self._element.getElement('.form_wrapper .close_btn');
				if (_close_btn) {
					_close_btn.addEvent('click', function () {
						self._popup.removeClass('_on_contact_form');
						_contact_btn.focus();
					});

					// focus on _close
					_close_btn.focus();
				}
			})
		}
	},

	build_close: function () {
		this.parent();

		if (this.options.backOnClose) {
			if (window.history.length == 1) {
				this.close.hide();
			}
		} else if (this.options.auto_open && !this.options.allowToClose) {
			this.close.hide();
		}
	},
	add_in_contract_functionality: function () {
		var self = this;
		let available_apts_link = this._element.getElement('a.available_apts');
		let available_apts_tab = this._element.getElement('.tab.available_apts');
		if (available_apts_tab) {
			let checkbox = available_apts_tab.querySelector('.in-contract-cb input');

			if (checkbox) {
				checkbox.addEventListener('change', function () {
					available_apts_link.classList.toggle('show-in-contract', this.checked);
					available_apts_tab.classList.toggle('show-in-contract', this.checked);
				});
			}
		}
	},

	add_links_functionality: function () {
		var self = this;

		/**
		 * This part is for v3 media popup, december 2023
		 */
		if (self._element && self._element.getElement) {
			var popupElement = self._element.getElement('.w_popup');
			if (popupElement && popupElement.hasClass && popupElement.hasClass('_v3')) {
				// This part below is to just make it friendly to the old code (initial load)
				this._overview_link = this._element.getElement('a.overview');
				this._videos_link = this._element.getElement('a.videos');
				this._pg_link = this._element.getElement('a.photogallery');
				this._fp_link = this._element.getElement('a.floorplan');
				this._sv_link = this._element.getElement('a.street_view');
				this._aa_link = this._element.getElement('a.available_apts');
				this._ph_link = this._element.getElement('a.price_history');
				this._mp_link = this._element.getElement('a.map_view');
				this._ae_link = this._element.getElement('a.aerial_view');
				this._st_link = this._element.getElement('a.street_view');
				this._vd_link = this._element.getElement('a.videos');


				// if it's current url
				var fullListingDetailsButton = self._element.getElement('a.listing-link');
				var closeButton = self._element.getElement('.w_popup_close');

				if (fullListingDetailsButton && closeButton) {
					var currentUrl = window.location.pathname + window.location.search;
					var listingUrl = fullListingDetailsButton.getAttribute('href');

					if (currentUrl === listingUrl) {
						fullListingDetailsButton.addEvent('click', function (e) {
							if (e && e.stop) e.stop();
							closeButton.click();
						});
					}
				}

				// Array of link types
				var linkTypes = ['overview', 'videos', 'photogallery', 'floorplan', 'street_view', 'price_history', 'available_apts', 'map_view', 'aerial_view'];

				// Process each link
				linkTypes.forEach(function (linkType) {
					var link = self._element.getElement('a.' + linkType);
					if (link) {
						link.addEvent('click', function (e) {
							if (e && e.stop) e.stop();
							popupElement.getElement('.lst_links').getElements('a').removeClass('_active');
							popupElement.getElements('.tab').removeClass('_active');
							popupElement.getElement('.tab.' + link.getAttribute('data-tab')).addClass('_active');
							link.addClass('_active');

							var mediaPopupContent = self._element.querySelector('.media_popup_content');
							if (mediaPopupContent) {
								mediaPopupContent.scrollTop = 0;
							}

							if (link.getAttribute('data-tab') == 'map_view' && !self._element.getElement('.map_view.tab').hasClass('loaded')) {
								self.set_new_map();
							}
							if (link.getAttribute('data-tab') == 'street_view' && !self._element.getElement('.street_view.tab').hasClass('loaded')) {
								self.set_new_streetview();
							}

							// reset video on tab change
							var videoIframe = self._element.getElement('.tab.videos iframe');
							if (videoIframe) {
								var iframeSrc = videoIframe.getAttribute('src');
								videoIframe.setAttribute('src', '');
								setTimeout(function () {
									videoIframe.setAttribute('src', iframeSrc);
								}, 50);
							}

						}.bind(this));
					}
				}, this);

				let floorplans = popupElement.getElement('.tab.floorplan');
				if (floorplans) {
					let fp_list = floorplans.getElements('.mansory-item');
					fp_list.forEach(function (e) {
						self.add_zoom_functionality(e);
					});
				}

				let photogallery = popupElement.getElement('.tab.photogallery');
				if (photogallery) {
					let photo_list = photogallery.getElements('.mansory-item');
					photo_list.forEach(function (e) {
						self.add_photo_zoom_functionality(e);
					});
				}
			}
		}

		if (!this._monitor) {
			return;
		}

		if (!this._monitor.getParent()) {
			this._monitor = this._element.getElement('.frame');
		}

		this._overview_link = this._element.getElement('a.overview');
		this._videos_link = this._element.getElement('a.videos');
		this._pg_link = this._element.getElement('a.photogallery');
		this._fp_link = this._element.getElement('a.floorplan');
		this._sv_link = this._element.getElement('a.street_view');
		this._aa_link = this._element.getElement('a.available_apts');
		this._ph_link = this._element.getElement('a.price_history');
		this._mp_link = this._element.getElement('a.map_view');
		this._ae_link = this._element.getElement('a.aerial_view');
		this._st_link = this._element.getElement('a.street_view');
		this._vd_link = this._element.getElement('a.video');

		if (this._videos_link) {
			this._videos_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_videos();
			});
		}

		if (!!this._pg_link) {
			this._pg_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_gallery();
			});
		}

		if (this._fp_link) {
			this._fp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_floorplan();
			});
		}

		if (this._sv_link) {
			this._sv_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_streetview();
			});
		}

		if (this._mp_link) {
			this._mp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_map();
			});
		}

		if (this._vd_link) {
			this._vd_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				self.set_video();
			});
		}

		setTimeout(function () {
			var tmpLinks = [this._overview_link, this._videos_link, this._pg_link, this._fp_link, this._mp_link, this._ae_link, this._sv_link, this._ph_link, this._aa_link, this._vd_link];
			var anyActiveLink = false;
			for (var i = 0; i < tmpLinks.length; i++) {
				if (tmpLinks[i] && tmpLinks[i].hasClass("_active")) {
					anyActiveLink = true;
					break;
				}
			}
			if (!anyActiveLink) {
				for (var i = 0; i < tmpLinks.length; i++) {
					if (tmpLinks[i]) {
						tmpLinks[i].fireEvent("click");
						break;
					}
				}
			}
		}, 0);
	},

	add_zoom_functionality: function (el) {
		var image = el.querySelector('img');
		var zoomLevel = 1;
		var isDragging = false;
		var dragStartX, dragStartY;

		var closeButton = document.createElement('button');
		closeButton.className = 'fullscreen';
		closeButton.textContent = 'Full Screen';
		closeButton.onclick = function () {
			el.toggleClass('fullscreen');
			if (el.classList.contains('fullscreen')) {
				document.body.style.overflow = 'hidden'; // hide the scrollbar
				document.body.style.maxHeight = '100vh';
			} else {
				document.body.style.overflow = ''; // restore
				document.body.style.maxHeight = '';
			}
		};
		el.appendChild(closeButton);

		var zoomInButton = document.createElement('button');
		zoomInButton.className = 'zoom-in';
		zoomInButton.textContent = '+';
		zoomInButton.onclick = function () {
			zoomLevel += 0.1;
			if (zoomLevel > 1 && image.src !== image.dataset.original) {
				image.removeAttribute('srcset');
				image.src = image.dataset.original;
			}
			updateTransform();
		};
		el.appendChild(zoomInButton);

		var zoomOutButton = document.createElement('button');
		zoomOutButton.className = 'zoom-out';
		zoomOutButton.textContent = '-';
		zoomOutButton.onclick = function () {
			if (zoomLevel > 0.2) {
				zoomLevel -= 0.1;
				updateTransform();
			}
		};
		el.appendChild(zoomOutButton);

		function updateTransform() {
			image.style.transform = `scale(${zoomLevel})`;
		}

		// dragging
		image.onmousedown = function (event) {
			event.preventDefault();
			isDragging = true;
			dragStartX = event.clientX - image.offsetLeft;
			dragStartY = event.clientY - image.offsetTop;

			document.onmousemove = dragImage;
			document.onmouseup = stopDragging;
		};

		function dragImage(event) {
			if (isDragging) {
				var posX = event.clientX - dragStartX;
				var posY = event.clientY - dragStartY;
				image.style.position = 'absolute'; // Ensure the image is positioned absolutely
				image.style.left = posX + 'px';
				image.style.top = posY + 'px';
			}
		}

		function stopDragging() {
			isDragging = false;
			document.onmousemove = null;
			document.onmouseup = null;
		}
	},

	toggleImageTag: function (event) {
		let target = event.target;
		if (target.closest('.meta')) {
			let metaDiv = target.closest('.meta');
			if (!metaDiv.classList.contains('small-only')) {
				metaDiv.classList.toggle('active');

				const shortText = metaDiv.querySelector('.short');
				const longText = metaDiv.querySelector('.long');

				if (metaDiv.classList.contains('active')) {
					metaDiv.style.height = `${longText.scrollHeight + 2}px`;
					metaDiv.style.width = `${longText.scrollWidth + 2}px`;
				} else {
					metaDiv.style.height = `${shortText.scrollHeight + 2}px`;
					metaDiv.style.width = `${shortText.scrollWidth + 2}px`;
				}

				event.stopPropagation();
				return true;
			}
		}
		return false;
	},

	add_photo_zoom_functionality: function (el) {
		let self = this;

		const metaDiv = el.querySelector('.meta');
		if (metaDiv) {
			const longText = metaDiv.querySelector('.long');

			const getHiddenDimensions = (element) => {
				let parent = element.closest('.tab');
				let originalStyles = {};

				// Temporarily show parent if it's hidden
				if (parent && window.getComputedStyle(parent).display === 'none') {
					originalStyles.display = parent.style.display;
					parent.style.display = 'block';
				}

				const dimensions = {
					height: element.scrollHeight + 2,
					width: element.scrollWidth + 2
				};

				// Revert parent to original state
				if (originalStyles.display !== undefined) {
					parent.style.display = originalStyles.display;
				}

				return dimensions;
			};

			setTimeout(() => {
				const { height, width } = getHiddenDimensions(longText);
				metaDiv.style.height = `${height}px`;
				metaDiv.style.width = `${width}px`;
			}, 100);
		}

		el.onclick = function (event) {
			if (self.toggleImageTag(event)) return;
			let grandParent = el.closest('.photogallery-layout');
			let overlay = grandParent.querySelector('.fullscreen-overlay');
			if (!overlay) {
				overlay = document.createElement('div');
				overlay.classList.add('fullscreen-overlay');
				overlay.innerHTML = `
					<div class="slider">
						<div class="close"></div>
						<div class="slider-wrapper">
							<div class="loader"></div>
						</div>
						<div class="slider-nav">
							<button class="slider-prev">&#8592;</button>
							<button class="slider-next">&#8594;</button>
						</div>
					</div>
				`;
				grandParent.appendChild(overlay);
			}
			overlay.classList.add('visible');

			// Cache DOM queries
			const sliderWrapper = overlay.querySelector('.slider-wrapper');
			const prevButton = overlay.querySelector('.slider-prev');
			const nextButton = overlay.querySelector('.slider-next');
			const closeButton = overlay.querySelector('.close');

			let photoList = Array.from(grandParent.querySelectorAll('.mansory-item'));
			let currentIndex = photoList.indexOf(el);

			sliderWrapper.innerHTML = '';
			photoList.forEach((photo, index) => {
				let slide = document.createElement('div');
				slide.classList.add('slider-item');
				if (index === currentIndex) {
					let clonedPhoto = photo.cloneNode(true);
					let clonedImage = clonedPhoto.querySelector('img');
					clonedImage.src = clonedImage.dataset.original;
					clonedImage.removeAttribute('srcset');
					clonedImage.style.display = 'block';
					clonedImage.ondragstart = self.preventImageDrag;
					slide.appendChild(clonedPhoto);
				}
				sliderWrapper.appendChild(slide);
			});
			if (photoList.length < 2) {
				prevButton.style.display = 'none';
				nextButton.style.display = 'none';
			}

			let sliderItems = sliderWrapper.querySelectorAll('.slider-item');
			self.updateSlider(sliderWrapper, currentIndex, sliderItems);

			prevButton.onclick = self.debounceSlider(function () {
				currentIndex = (currentIndex > 0) ? currentIndex - 1 : sliderItems.length - 1;
				self.updateSlider(sliderWrapper, currentIndex, sliderItems);
				self.loadImages(sliderItems, photoList, currentIndex);
			}, 200);

			nextButton.onclick = self.debounceSlider(function () {
				currentIndex = (currentIndex < sliderItems.length - 1) ? currentIndex + 1 : 0;
				self.updateSlider(sliderWrapper, currentIndex, sliderItems);
				self.loadImages(sliderItems, photoList, currentIndex);
			}, 200);

			// Add swipe functionality
			let startX = 0;
			let endX = 0;

			sliderWrapper.addEventListener('touchstart', function (event) {
				startX = event.touches[0].clientX;
			});

			sliderWrapper.addEventListener('touchmove', function (event) {
				endX = event.touches[0].clientX;
			});

			sliderWrapper.addEventListener('touchend', function () {
				handleSwipe();
			});

			sliderWrapper.addEventListener('mousedown', function (event) {
				startX = event.clientX;
				sliderWrapper.addEventListener('mousemove', onMouseMove);
			});

			sliderWrapper.addEventListener('mouseup', function (event) {
				endX = event.clientX;
				sliderWrapper.removeEventListener('mousemove', onMouseMove);
				handleSwipe();
			});

			sliderWrapper.addEventListener('mouseleave', function (event) {
				sliderWrapper.removeEventListener('mousemove', onMouseMove);
			});

			function onMouseMove(event) {
				endX = event.clientX;
			}

			function handleSwipe() {
				if (startX - endX > 50) {
					currentIndex = (currentIndex < sliderItems.length - 1) ? currentIndex + 1 : 0;
				} else if (endX - startX > 50) {
					currentIndex = (currentIndex > 0) ? currentIndex - 1 : sliderItems.length - 1;
				}
				self.updateSlider(sliderWrapper, currentIndex, sliderItems);
				self.loadImages(sliderItems, photoList, currentIndex);
			}

			function handleOverlayClick(event) {
				const grandparentElement = event.target.parentElement.parentElement;
				if (grandparentElement && grandparentElement.classList.contains('meta')) {
					self.toggleImageTag(event);
					return;
				}
				if (event.target !== prevButton && event.target !== nextButton && event.target.tagName !== 'IMG') {
					overlay.classList.remove('visible');
					resetSlider();
				}
			}

			// Attach the listener only once
			if (!overlay.dataset.listenerAttached) {
				overlay.addEventListener('click', handleOverlayClick);
				overlay.dataset.listenerAttached = true; // Use a flag to ensure it's not added again
			}

			closeButton.onclick = function () {
				overlay.classList.remove('visible');
				resetSlider();
			};

			function resetSlider() {
				sliderWrapper.innerHTML = '';
				// prevButton.style.display = '';
				// nextButton.style.display = '';
			}

			// Initial load of the current image, previous image, and next image
			self.loadImages(sliderItems, photoList, currentIndex);
		}.bind(this);
	},

	updateSlider: function (sliderWrapper, index, sliderItems) {
		let offset = -index * 100;
		sliderWrapper.style.transform = `translateX(${offset}%)`;
		sliderItems.forEach((item, i) => {
			if (i === index) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
		});
	},

	preventImageDrag: function (event) {
		event.preventDefault();
	},

	// Debounce function to limit the rate of function calls
	debounceSlider: function (func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	},

	// Load images function for lazy loading with preloading adjacent images
	loadImages: function (sliderItems, photoList, currentIndex) {
		const indicesToLoad = [currentIndex];
		const totalItems = sliderItems.length;

		if (currentIndex > 0) {
			indicesToLoad.push(currentIndex - 1); // Previous image
		} else {
			indicesToLoad.push(totalItems - 1); // Wrap around to last image if at start
		}

		if (currentIndex < totalItems - 1) {
			indicesToLoad.push(currentIndex + 1); // Next image
		} else {
			indicesToLoad.push(0); // Wrap around to first image if at end
		}

		indicesToLoad.forEach(index => {
			const slide = sliderItems[index];
			const photo = photoList[index];
			if (!slide.querySelector('img')) {
				let clonedPhoto = photo.cloneNode(true);
				let clonedImage = clonedPhoto.querySelector('img');
				clonedImage.src = clonedImage.dataset.original;
				clonedImage.removeAttribute('srcset');
				clonedImage.style.display = 'block';
				clonedImage.ondragstart = this.preventImageDrag;
				slide.innerHTML = '';
				slide.appendChild(clonedPhoto);
			}
		});
	},

	set_videos: function () {
		var self = this;

		this.inactivate_links('videos');
		this.empty_monitor_content('videos');
		this._videos_link.addClass('_active');

		if (!this._videos) {

			this.videogallery = new PagePhotogalleryV2(this._monitor, {
				thumbs_amount: (this.options.fullscreen || this.options.withThumbnails) ? 1 : 0,
				in_popup: true,
				missing_img: Res_i + '/l/video-default.svg',
				videosOnly: true,
				onCallback: function () {
					self._videos = self._monitor.getElement('.w_photogalleryv2') || self._monitor.getElement('img');
				}
			});
		} else {
			this._videos.inject(this._monitor);
			if (!!this.videogallery && !!this.videogallery.pg && !!this.videogallery.pg.current_index) {
				this.videogallery.pg.scrollMainToPosition(this.videogallery.pg.current_index);
			}
		}
	},

	inactivate_links: function (excludeType) {
		if (excludeType != 'videos' && this._videos_link) {
			this._videos_link.removeClass('_active');
		}
		if (excludeType != 'sv' && this._sv_link) {
			this._sv_link.removeClass('_active');
		}
		if (excludeType != 'fp' && this._fp_link) {
			this._fp_link.removeClass('_active');
		}
		if (excludeType != 'mp' && this._mp_link) {
			this._mp_link.removeClass('_active');
		}
		if (excludeType != 'ae' && this._ae_link) {
			this._ae_link.removeClass('_active');
		}
		if (excludeType != 'vd' && this._vd_link) {
			this._vd_link.removeClass('_active');
		}
		if (excludeType != 'pg' && this._pg_link) {
			this._pg_link.removeClass('_active');
		}
	},

	empty_monitor_content: function (excludeType) {
		if (excludeType != 'videos' && this._videos) {
			this._videos.dispose();
		} else {

		}

		if (excludeType != 'fp' && this._fp) {
			this._fp.dispose();
		} else {

		}

		if (excludeType != 'sv' && this._sv) {
			this._sv.dispose();
		} else {

		}

		if (excludeType != 'mp' && this._mp) {
			this._mp.dispose();
		} else {

		}

		if (excludeType != 'pg' && this._pg) {
			this._pg.dispose();
		} else {

		}

		if (excludeType != 'vd' && this._vd) {
			this._vd.dispose();
		} else {

		}
	},

	set_gallery: function () {
		var self = this;

		this.inactivate_links('pg');
		this.empty_monitor_content('pg');
		this._pg_link.addClass('_active');

		if (!this._pg) {
			this.pagePhotogallery = new PagePhotogalleryV2(this._monitor, {
				thumbs_amount: (this.options.fullscreen || this.options.withThumbnails) ? 1 : 0,
				in_popup: true,
				fullscreen_mode: this.options.fullscreen,
				missing_img: Res_i + '/l/not-found-grey-new-gallery-big-v2-1.png',
				onCallback: function () {
					self._pg = self._monitor.getElement('.w_photogalleryv2') || self._monitor.getElement('img');
				}
			});

		} else {
			this._pg.inject(this._monitor);
			if (!!this.pagePhotogallery && !!this.pagePhotogallery.pg && !!this.pagePhotogallery.pg.current_index) {
				this.pagePhotogallery.pg.scrollMainToPosition(this.pagePhotogallery.pg.current_index);
			}
		}
	},

	set_floorplan: function () {
		var self = this;

		this.inactivate_links('fp');
		this.empty_monitor_content('fp');
		this._fp_link.addClass('_active');

		if (!this._fp) {
			this.floorgallery = new PagePhotogalleryV2(this._monitor, {
				data: this._fp_link.data,
				thumbs_amount: (this.options.fullscreen || this.options.withThumbnails) ? 1 : 0,
				missing_img: Res_i + '/l/not-found-grey-new-gallery-big-v2-1.png',
				show_floorplan: true,
				onCallback: function () {
					self._fp = self._monitor.getElement('.w_photogalleryv2');
				}
			});
		} else {
			// this._monitor.adopt(this._fp);
			this._fp.inject(this._monitor);
			if (!!this.floorgallery && !!this.floorgallery.pg && !!this.floorgallery.pg.current_index) {
				this.floorgallery.pg.scrollMainToPosition(this.floorgallery.pg.current_index);
			}
		}
	},

	set_streetview: function () {
		var self = this;

		this.inactivate_links('sv');
		this.empty_monitor_content('sv');
		this._sv_link.addClass('_active');

		if (!this._sv) {
			self._monitor.addClass('_loading');

			new Remote({
				rpc: self._sv_link.get('data-rpc-map'),
				onSuccess: function () {
					var sv_data = this.get_data();

					if (sv_data) {
						var html = '<div class="w_streetview_map"></div>' +
							'<div class="w_streetview_pano"></div>' +
							'<div class="none w_streetview_config">' +
							'{' +
							'"lat": ' + (sv_data.ini.lat || 40.7611181) + ',' +
							'"lng": ' + (sv_data.ini.lng || -73.9774162) +
							'}' +
							'</div>';

						self._sv = new Element('div', {
							'class': 'street_view_map',
							'html': html
						}).inject(self._monitor);

						new Streetview(self._sv);

						self._monitor.removeClass('_loading');
					}
				}
			});
		} else {
			this._sv.inject(self._monitor);
		}
	},

	set_map: function () {
		var self = this;

		this.inactivate_links('mp');
		this.empty_monitor_content('mp');
		this._mp_link.addClass('_active');

		if (!this._mp) {
			self._monitor.addClass('_loading');

			new Remote({
				rpc: self._mp_link.get('data-rpc-map'),
				method: 'get',
				onSuccess: function () {
					var mp_data = this.get_data();

					if (mp_data) {
						self._mp = new Element('div', {
							'class': 'map'
						}).inject(self._monitor);
						self.map = new SimpleMap(self._mp, {
							zoom: mp_data.ini.zoom,
							max_zoom: 22,
							min_zoom: 10,
							lat: mp_data.ini.lat,
							lng: mp_data.ini.lng,
							transit_layer: true,
							type_control: true,
							street_view_control: true,
							onMapReady: function () {
								this.add_marker({
									lat: mp_data.ini.lat,
									lng: mp_data.ini.lng,
									icon: mp_data.ini.markers_path + 'icon_mappin.svg',
									bubble_content: mp_data.base_location.name
								});
							}
						});
						self._monitor.removeClass('_loading');
					}
				}
			});
		} else {
			this._mp.inject(self._monitor);
		}
	},

	set_new_streetview: function () {
		var self = this;

		self._element.getElement('.tab.street_view').addClass('loading');

		new Remote({
			rpc: self._sv_link.get('data-rpc-map'),
			onSuccess: function () {
				var sv_data = this.get_data();

				self._element.getElement('.tab.street_view').removeClass('loading').addClass('loaded');
				if (sv_data) {
					var html = '<div class="w_streetview_map"></div>' +
						'<div class="w_streetview_pano"></div>' +
						'<div class="none w_streetview_config">' +
						'{' +
						'"lat": ' + (sv_data.ini.lat || 40.7611181) + ',' +
						'"lng": ' + (sv_data.ini.lng || -73.9774162) +
						'}' +
						'</div>';

					self._sv = new Element('div', {
						'class': 'street_view_map',
						'html': html
					}).inject(self._element.getElement('.tab.street_view'));

					new Streetview(self._sv);

				}
			}
		});
	},

	set_new_map: function () {
		var self = this;

		self._element.getElement('.tab.map_view').addClass('loading');
		new Remote({
			rpc: self._mp_link.get('data-rpc-map'),
			method: 'get',
			onSuccess: function () {
				var mp_data = this.get_data();

				if (mp_data) {
					self._element.getElement('.tab.map_view').removeClass('loading').addClass('loaded');
					self._mp = self._element.getElement('.map');
					self.map = new SimpleMap(self._mp, {
						zoom: mp_data.ini.zoom,
						max_zoom: 22,
						min_zoom: 10,
						lat: mp_data.ini.lat,
						lng: mp_data.ini.lng,
						transit_layer: true,
						//type: 'hybrid',
						type_control: true,
						street_view_control: false,
						onMapReady: function () {
							this.add_marker({
								lat: mp_data.ini.lat,
								lng: mp_data.ini.lng,
								icon: mp_data.ini.markers_path + 'icon_mappin.svg',
								bubble_content: mp_data.base_location.name
							});
						}
					});
				}
			}
		});
	},

	set_video: function () {
		var self = this;

		this.inactivate_links('vd');
		this.empty_monitor_content('vd');
		this._vd_link.addClass('_active');

		if (!this._vd) {
			var id = 'vimeo_' + Math.floor((Math.random() * 1000) + 1);

			this._vd = new Element('div.video_container', {
				'html': '<iframe id="' + id + '" src="' + ('https:' == document.location.protocol ? 'https://' : 'http://') + 'player.vimeo.com/video/' + this._vd_link.getAttribute('data-vimeo-id') + '?api=1&player_id=' + id + '" width="100%" height="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>'
			}).inject(self._monitor);
			self._monitor.removeClass('_loading');

		} else {
			this._vd.inject(self._monitor);
		}
	},

	show_widget: function (widget) {
		this.new_widget = widget;
		var self = this;
		var _el = null;

		widget = widget || this.options.display;
		// display the current widget
		switch (widget) {
			case 'overview':
				if (this._overview_link) {
					_el = this._overview_link;
				} else if (this._pg_link) {
					_el = this._pg_link;
				} else {
					_el = this._mp_link;
				}
				break;
			case 'video':
				_el = this._videos_link;
				break;
			case 'floorplan':
				_el = this._fp_link;
				break;
			case 'map':
				_el = this._mp_link;
				break;
			case 'streetview':
				_el = this._st_link;
				break;
			case 'aerial_view':
				_el = this._ae_link;
				break;
			case 'video-bld':
				_el = this._vd_link;
				break;
			case 'gallery':
				_el = this._pg_link;
				break;
			case 'apts':
				_el = this._aa_link;
				break;
			case 'phistory':
				_el = this._ph_link;
				break;
			default:
				_el = this._pg_link;
		}

		if (!!_el && !_el.hasClass('_active')) {
			if (_el.hasClass)
				_el.fireEvent('click');
		}
	},

	build_draggable: function () {
	},
});

//static
Blimp.instances = [];

function copyToClipboard(element, text) {
	// Copy text to clipboard
	const tempInput = document.createElement('input');
	tempInput.value = text;
	document.body.appendChild(tempInput);
	tempInput.select();
	document.execCommand('copy');
	document.body.removeChild(tempInput);

	// Change button text to "Copied"
	const originalText = element.innerHTML;
	element.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i> Copied';

	// Revert text back after 3 seconds
	setTimeout(() => {
		element.innerHTML = originalText;
	}, 3000);
}